module.exports = __webpack_public_path__ + "static/media/XVIIh.268ac9de.png";